/**
 * Facebook in-app browser 检测与外部浏览器跳转工具
 */

const ua = () => navigator.userAgent || ''

export function isFbBrowser() {
  const u = ua()
  return u.includes('FBAN') || u.includes('FBAV')
}

export function isIosDevice() {
  return /iPad|iPhone|iPod/.test(ua())
}

export function isAndroidDevice() {
  return /Android/.test(ua())
}

/**
 * 用 x-safari-https scheme 在 Safari 中打开当前页面。
 * Safari 是 iOS 系统内置应用，不可卸载，不存在失败场景。
 */
export function openInSafari(targetUrl) {
  const url = targetUrl || window.location.href
  window.location.href = url.replace(/^https?:\/\//, 'x-safari-https://')
}

/**
 * 用 Chrome URL scheme 在 Chrome 中打开当前页面（iOS 适用）。
 * googlechromes:// 在 iOS 的 Facebook WebView 中可正常跳出到 Chrome。
 */
export function openInChrome() {
  const url = window.location.href
  window.location.href = url
    .replace(/^https:\/\//, 'googlechromes://')
    .replace(/^http:\/\//, 'googlechrome://')
}

/**
 * 用 Android intent:// scheme 跳转到外部浏览器（Android 适用）。
 * - Chrome 已安装 → 在 Chrome 中打开
 * - Chrome 未安装 → S.browser_fallback_url 兜底，由系统默认浏览器打开
 * googlechromes:// 在 Android Facebook WebView 中会被拦截报错，intent:// 则由 OS 直接派发，不经过 WebView。
 */
export function openInChromeAndroid(targetUrl) {
  const url = targetUrl || window.location.href
  const scheme = url.startsWith('https') ? 'https' : 'http'
  const withoutScheme = url.replace(/^https?:\/\//, '')
  const fallback = encodeURIComponent(url)
  window.location.href = `intent://${withoutScheme}#Intent;scheme=${scheme};package=com.android.chrome;S.browser_fallback_url=${fallback};end`
}

/**
 * 在 FB in-app browser 中，根据设备类型自动跳转到外部浏览器。
 * iOS → Safari，Android → Chrome。
 * @returns {boolean} 是否触发了跳转
 */
export function redirectToExternalBrowser() {
  if (!isFbBrowser()) return false
  if (isIosDevice()) {
    openInSafari()
  } else if (isAndroidDevice()) {
    openInChromeAndroid()
  }
  return true
}

/**
 * 读取 autoOutside 参数，兼容两种 URL 格式：
 *   1. #/reading?autoOutside=0  （hash 模式路由 query）
 *   2. ?autoOutside=0#/reading  （# 前的 search 参数）
 * @param {object} routeQuery  this.$route.query
 */
export function getAutoOutside(routeQuery) {
  if (routeQuery && routeQuery.autoOutside != null) {
    return routeQuery.autoOutside
  }
  return new URLSearchParams(window.location.search).get('autoOutside')
}
